export const SELECT_PDP_TOOLTIP_PRODUCT = 'LS_DESIGN_VIEWER/SELECT_PDP_TOOLTIP_PRODUCT';
export const SELECT_RENDER = 'LS_DESIGN_VIEWER/SELECT_RENDER';
export const CLEAR_RENDER = 'LS_DESIGN_VIEWER/CLEAR_RENDER';
export const SELECT_VIEW_MODE = 'LS_DESIGN_VIEWER/SELECT_VIEW_MODE';
export const SELECT_DESIGNS_FILTER = 'LS_DESIGN_VIEWER/SELECT_DESIGNS_FILTER';
export const SET_PANORAMA_VIEWER_OPEN_FLAG = 'LS_DESIGN_VIEWER/SET_PANORAMA_VIEWER_OPEN_FLAG';
export const TOGGLE_FULL_SCREEN_RENDER = 'LS_DESIGN_VIEWER/TOGGLE_FULL_SCREEN_RENDER';
export const UPDATE_HOTSPOT_STATUS = 'LS_DESIGN_VIEWER/UPDATE_HOTSPOT_STATUS';
export const RECEIVE_ALTERNATIVES = 'LS_DESIGN_VIEWER/RECEIVE_ALTERNATIVES';
export const AWAITING_ALTERNATIVES = 'LS_DESIGN_VIEWER/AWAITING_ALTERNATIVES';
export const ALTERNATIVES_REQUEST_ERROR = 'LS_DESIGN_VIEWER/ALTERNATIVES_REQUEST_ERROR';
export const ALTERNATIVES_ID = 'LS_DESIGN_VIEWER/ALTERNATIVES_ID';
export const SET_ALLOW_SWIPE = 'LS_DESIGN_VIEWER/SET_ALLOW_SWIPE';
export const SET_FORCE_RENDER_ON_DESIGN_CHANGE = 'LS_DESIGN_VIEWER/FORCE_RENDER_ON_DESIGN_CHANGE';
export const SET_MORE_MENU_OPEN = 'LS_DESIGN_VIEWER/SET_MORE_MENU_OPEN';
export const SET_DESIGN_NOTIFICATION = 'LS_DESIGN_VIEWER/SET_DESIGN_NOTIFICATION';
export const SET_SHOW_MOBILE_HOTSPOTS = 'LS_DESIGN_VIEWER/SET_SHOW_MOBILE_HOTSPOTS';
export const SET_MOBILE_HOTSPOTS_VIEW = 'LS_DESIGN_VIEWER/SET_MOBILE_HOTSPOTS_VIEW';
